
import React, { memo,useEffect,useState } from 'react';
import { Layout, Menu, Breadcrumb,Row, Col, Button, Table, Tag, Drawer, Form, Select, Input, Space, message, Modal, Switch } from 'antd';
import { EditOutlined, SendOutlined, DeleteOutlined,PlusOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { addDataWithToken, deleteDataWithToken, editDataWithToken, getDataWithToken } from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
const {Content} = Layout;
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const {confirm} = Modal

const pageTitle = 'ادارة الاقسام';

const  MngDeparts = ()=> {
    const navigate = useNavigate();
    const [addDepartForm] = Form.useForm()
    const [editDepartForm] = Form.useForm()

    const [addDepartVisible, setAddDepartVisible] = useState(false);
    const [editDepartVisible, setEditDepartVisible] = useState(false);
    
    const [addLoading, setAddLoading] = useState(false);
    const [selectedDepart, setSelectedDepart] = useState(null)
    const [departFormInfo, setDepartFormInfo] = useState(null)
    const [departs, setDeparts] = useState([]);
    const [totalCount, setTotalCount] = useState(null);

    

    const handleTableChange = (pagination, filters, sorter) => {
        const{current,pageSize} = pagination 
        getDeparts(current,pageSize)
      };


      const onAddClose = () => {
        setAddDepartVisible(false);
        setSelectedDepart(null)
        addDepartForm.resetFields()
        
      };

      const onEditClose = () => {
        setEditDepartVisible(false);
        setSelectedDepart(null)
        editDepartForm.resetFields()
        
      };

   
   

      const getDeparts = (current=1,pageSize=25)=>{
        setAddLoading(true)
        getDataWithToken(`departs?pagination[pageSize]=${pageSize}&pagination[page]=${current}`,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setDeparts(result?.data);
            setTotalCount(result?.meta?.total)
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      const addDepart = (data)=>{
        setAddLoading(true)
        addDataWithToken(`departs`,data,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            message?.success('تم اضافة القسم بنجاح');
            getDeparts();
            addDepartForm?.resetFields();
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      function showDeleteConfirm(A_field_name,id) {
        confirm({
            title: `  هل انت متأكد انك تريد حذف  ( ${A_field_name} )  `,
            icon: <ExclamationCircleOutlined style={{color:'red'}} />,
            content: 'ملاحظة : البيانات المحذوفة لا يمكن استعادتها لاحقا',
            okText: 'نعم',
            okType: 'danger',
            cancelText: 'الغاء',
            width:480,
            style:{textAlign:'right'},
            onOk() {
                setAddLoading(true);
                deleteDataWithToken(`departs/${id}`,(err, result)=>{

                    const {error} = result
                    if(err){
                        message?.error('خطأ في الشبكة')
                    }else{
                        if(!error){
                            message?.success('تم حذف القسم بنجاح');
                            getDeparts();
                        }else{
                            console.log(error)
                            message?.error(error?.message)
                        }
                    
                    }
                })

            },
            onCancel() {
                console.log('Cancel');
            },
            });
        }   

        const prepareEdit = (data)=>{
            console.log(data)
            setSelectedDepart(data)
            const newData = data
            editDepartForm.setFieldsValue(newData)
            setEditDepartVisible(true)
        }

        const editDepart = (data)=>{
         
            setAddLoading(true);
            editDataWithToken(`departs/${selectedDepart?.id}`,data,(err, result)=>{
                const {error} = result
                if(err){
                    message?.error('خطأ في الشبكة')
                }else{
                    if(!error){
                        message?.success('تم تعديل القسم بنجاح');
                        getDeparts();
                    }else{
                        console.log(error)
                        message?.error(error?.message)
                    }
                
                }
            })
          }


      useEffect(() => {
       getDeparts();
      }, [])
      
    
    
    return(
        <Layout className='mainContainer'>

            <Drawer
                    title="اضافة قسم"
                    placement="left"
                    closable={false}
                    onClose={onAddClose}
                    visible={addDepartVisible}
                    width={350}
                >
                <Form 
                    form={addDepartForm} 
                    onFinish={addDepart}
                    onValuesChange={(changedValues,allValues)=>{
                        setDepartFormInfo(allValues);
                    }}
                    layout='vertical'
                >

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="title" 
                        label="اسم القسم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة اسم القسم',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="اسم القسم"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    {/* <Form.Item label="مفعل" name="active" valuePropName="checked" >
                        <Switch  />
                    </Form.Item> */}
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0}}  type="primary"  icon={<SendOutlined />} onClick={()=>{addDepartForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>


            <Drawer
                    title={`تعديل ${selectedDepart?.title}`}
                    placement="left"
                    closable={false}
                    onClose={onEditClose}
                    visible={editDepartVisible}
                    width={350}
                >
                <Form 
                    form={editDepartForm} 
                    onFinish={editDepart}
                    onValuesChange={(changedValues,allValues)=>{
                        setDepartFormInfo(allValues);
                    }}
                    layout='vertical'
                >

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="title" 
                        label="اسم القسم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة اسم القسم',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="اسم القسم"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    {/* <Form.Item label="مفعل" name="active" valuePropName="checked" >
                        <Switch  />
                    </Form.Item> */}
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0}}  type="primary"  icon={<SendOutlined />} onClick={()=>{editDepartForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>
        
            <GlobalHeader title={pageTitle}/>
            <Layout>
            
            <GlobalSider currentPage={'departs'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item onClick={()=>navigate('/mnghome')}  style={{cursor: 'pointer'}} >الرئيسية</Breadcrumb.Item>
                <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
                
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row  style={{padding:10}} >

                <Col md={24} >
                    <Button onClick={()=> setAddDepartVisible(true) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<PlusOutlined />} size={20}>
                        اضافة  قسم
                    </Button>
                   </Col>

                    <Col md={24} style={{marginTop:24}}>

                    <Table 
                        dataSource={departs}
                        pagination={{ position: ['bottomCenter'],total:totalCount}}
                        onChange={handleTableChange}
                        loading={addLoading}
                        scroll={{ x: '100%'}}
                    >

                    

                        <Column title="اسم القسم"  width="200px" key="title" 
                            render={(text, record) => (
                                <Space>
                                    {`${record?.university?.title}  -  ${record?.college?.title} - ${record?.title}`}
                                </Space>
                                
                            )}
                        />

                        {/* <Column  width={150} title="مفعل"  key="active" 
                            render={(text, record) => (
                                <Space>
                                    {record?.attributes?.active === true ? <Tag color={'green'}  >مفعل </Tag> : <Tag  color={'red'} >غير مفعل</Tag> }
                                </Space>
                            
                            )}
                             
                        />  */}

                         <Column title="العمليات"  width="200px" key="status" 
                            render={(text, record) => (
                                <Space>
                                <Button onClick={()=> prepareEdit(record) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<EditOutlined />} size={20}>
                                    تعديل
                                </Button>

                                <Button onClick={()=> showDeleteConfirm(record?.title, record?.id) } style={{backgroundColor:Colors.red, borderWidth:0}} type="primary" shape="round" icon={<DeleteOutlined />} size={20}>
                                     حذف
                                </Button>
                                </Space>
                                
                            )}
                        />
                
                    </Table>

                    </Col>
                   
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngDeparts




